import { ADD_SOCIAL_NETWORK } from './types';

import instagram from '../../assets/images/social-networks/instagram.png';
import linkedin from '../../assets/images/social-networks/linkedin.png';

const initialState = [
  {
    order: 1,
    name: 'instagram',
    img: instagram,
    url: 'https://www.instagram.com/radical_departures/?hl=en'
  },
  {
    order: 2,
    name: 'linkedin',
    img: linkedin,
    url: 'https://www.linkedin.com/company/1166963/'
  }
];

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_SOCIAL_NETWORK:
      return [...state, action.payload];
    default:
      return state;
  }
};

export { reducer as socialNetworksReducer };



// WEBPACK FOOTER //
// ./src/store/SocialMedia/reducer.js